import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function ProtectedRoute({ children }) {
  const { isAuthenticated, token, usuario, tipoUsuario, authChecked } = useAuth();

  if (!authChecked) return null;

  if (!isAuthenticated || !token || !usuario || tipoUsuario !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;